// removed by extract-text-webpack-plugin
module.exports = {"sec":"NewUserTitle__sec__3O8xtImG","title_con":"NewUserTitle__title_con__13kKMlrq","border_left":"NewUserTitle__border_left__1kInQZgs","border_right":"NewUserTitle__border_right__3JI9FsCp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewUserTitle/NewUserTitle.scss
// module id = m+Ry
// module chunks = 0